.graphic-container {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.graphic {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 80%;
}

.graphic > svg {
    width: 150px;
    margin-top: 41px;
}

.entity {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.icon-background {
    composes: background from '../graphics-pieces/icon-background.module.css';
}

.subtitle {
    color: var(--grey-dk);
    font-style: italic;
}
